import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idWorldEvent']),
      
        getAllByWork: (state, getters, rootState) => workFilter => {
            if(workFilter === 'my') {
                return state.objs;
            } else {
                return state.objs.filter(e => e.work == workFilter);
            }
        },
        getMyEvents: (state, getters, rootState, rootGetters) => (user) => {
           // console.log(state);
            // Ammetto eventi solo se l'utente è creatore o se ha un invito per esso
            //return state.objs.filter(e => (e.creator === user || 
            //rootGetters["invites/getAll"].filter(invite => (invite.event === e.idWorldEvent) && (invite.user === user))));
            return state.objs.filter(function(e){
                var created = e.creator === user;
                var invited = false;
                var result ;
                rootGetters["invites/getAll"].forEach(invite => {
                    invited = (invite.event === e.idWorldEvent && invite.user === user);
                    if (invited) {
                        result = invited;
                    }   
                });
                return created || result;
            });
        },
       
    },
    mutations: {
        ...functions.createDefaultMutations(['idWorldEvent'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idWorldEvent'])
    },
}